<template>
  <div class="formGroup" :data-layout="layout">
    <div class="formGroup__body">
      <form-label-fes :label="label" :validation="validation"></form-label-fes>
      <input
        ref="input"
        class="formControl"
        v-validate="validation"
        :data-error="errors.has(name)"
        :type="type"
        :name="name"
        :maxlength="validation.rules.max"
        :placeholder="placeholder"
        @input="update($event)"
      >
    </div>
    <div class="formGroup__footer">
      <slot></slot>
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-input-fes',
  mixins: [mixin],
  props: {
    type: { type: String, default: 'text' }
  }
}</script>


<style lang="scss" scoped>
.formControl {
  width: 120px;
  border: 1px solid #C5C5C4;
  border-radius: 6px;
  background: #fff;
  height: 44px;
  padding: 14px 12px;
  font-size: 15px;
  line-height: 1;
  &[data-error="true"] {
    border: 1px solid #EB2000;
  }

}
</style>



// WEBPACK FOOTER //
// resources/assets/js/uFes/components/FormInputFes.vue